import { useTranslation } from 'react-i18next'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { AX_PRODUCT_TYPES, type AxProductType } from '@/services/earnings/axProductsApi'

export type ProductTypeFilterValue = 'all' | AxProductType

interface ProductTypeFilterProps {
  value: ProductTypeFilterValue
  onChange: (value: ProductTypeFilterValue) => void
}

/** A marketplace product type picker for list filters. */
export function ProductTypeFilter({ value, onChange }: ProductTypeFilterProps) {
  const { t } = useTranslation()

  return (
    <Select value={value} onValueChange={(v) => onChange((v ?? 'all') as ProductTypeFilterValue)}>
      <SelectTrigger className="h-8 w-full text-sm">
        <SelectValue>{value === 'all' ? t('common.all') : t(`products.type_${value}`)}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">{t('common.all')}</SelectItem>
        {AX_PRODUCT_TYPES.map((type) => (
          <SelectItem key={type} value={type}>
            {t(`products.type_${type}`)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
